var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tabs is-toggle has-custom-scrollbar"},[_c('ul',_vm._l((_vm.menuItems),function(item,index){return _c('li',{key:'m_' + index,class:_vm.$route.name.includes(item.view) ? 'is-active' : 'has-background-white'},[_c('router-link',{attrs:{"to":{
        name: item.view, params: {
          locationId: _vm.locationId
        } }}},[_vm._v(" "+_vm._s(item.label)+" ")])],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }